module.exports = __webpack_public_path__ + "img/magnifying-glass.5d65b94e.svg";